const BASE_URL = 'https://api.candlive.com/v1/'
const SOCKET_URL = 'https://api.candlive.com/'

export { BASE_URL, SOCKET_URL }
